import { INVALID_COUPON } from '../actions/coupon'

export default (state = false, action = {}) => {
  switch (action.type) {
    case INVALID_COUPON:
      return !state
    default:
      return state
  }
}